import isEmpty from 'lodash/isEmpty'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/mapTo'
import * as App from '../../../app'
import * as CommunityConfig from '../../../pages/community-config/actions'

export const epic = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<any>,
) => action$.ofType(App.AUTHENTICATED)
  .filter(() => isEmpty(store.getState().communities))
  .mapTo(CommunityConfig.fetchCommunities())



// WEBPACK FOOTER //
// ./src/components/menu/user-menu/epic.ts